import React, { Component } from 'react';
import { Form, Image, Button, InputGroup } from 'react-bootstrap';
import Validator, { ValidationTypes } from 'js-object-validation';
import { message } from '../../common/messages';
import { IForgotPasswordProps, IForgotPasswordState } from '../../interfaces';
import mailIcon from '../../assets/images/auth/mail.png';

class ForgotPassword extends Component<
  any,
  IForgotPasswordState
  > {
  constructor(props: any) {
    super(props);
    this.state = {
      email: '',
      errors: {
        email: '',
      },
    };
  }
  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    this.setState({
      ...this.state,
      [name]: value,
      errors: {
        ...this.state.errors,
        [name]: '',
      },
    });
  };

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // return
    const { email } = this.state;
    const data = {
      email: email ? email.trim().toLowerCase() : '',
    };
    // To validate form fields
    const validations = {
      email: {
        [ValidationTypes.REQUIRED]: true,
        [ValidationTypes.EMAIL]: true,
      },
    };
    const messages = {
      email: {
        [ValidationTypes.EMAIL]: message.InvalidEmail,
        [ValidationTypes.REQUIRED]: message.RequiredEmail,
      },
    };
    const { isValid, errors } = Validator(data, validations, messages);
    if (isValid) {
      this.props.forgotPasswordReq(email);
    } else {
      this.setState({
        errors,
      });
      return;
    }
  };
  render() {
    const { email, errors } = this.state;
    return (
      <div className={'login-form'}>
        <h5>
          <span>{this.props.checkPage}</span> your Password?{this.props.forgotEnabled}
        </h5>
        <div className={'mt-20 mx-sm-4'}>Enter your email address associated with your account and we will send you a link to reset your password.</div>
        <Form onSubmit={this.handleSubmit}>
          <Form.Group controlId='formBasicEmail'>
            <InputGroup>
              <input
                type={'text'}
                name={'email'}
                value={email}
                className={'form-control form-input'}
                placeholder=' '
                onChange={this.handleChange}
              />
              <Form.Label className={`login-form-label ${email ? 'top-label' : ''}`}>
                Email Address
              </Form.Label>
              <span className='login-icon'>
                <Image src={mailIcon} />
              </span>
            </InputGroup>
            <div className={'text-danger error-field'}>
              {errors && errors.email}
            </div>
          </Form.Group>
          <div className='text-center my-4'>
            <Button type='submit' className='btn-submit login-btn'>
              Submit
            </Button>
          </div>
          {this.props.checkPage == 'Forgot' ? (
            <div>
          <div className='divider text-center mb-2'>
            <span>OR</span>
          </div>
          <p className='text-center'>
            Remember your password?{' '}
            <span className='forget-link' onClick={this.props.showLoginModal}>
              Login
            </span>
          </p>
          </div>
          )
          : ""
          }
        </Form>
      </div>
    );
  }
}

export default ForgotPassword;
